// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { array, func, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import columns from './columns'
import handleSpecificAnalysisStatusSelection from 'redux/modules/interferenceAnalysis/thunks/handleSpecificAnalysisStatusSelection'
import { DataTable } from 'components'
import { useStatusesTable } from './hooks'

const StatusesTable = props => {
  const {
    closeModal,
    data,
    idRoot,
  } = props

  const dispatch = useDispatch()

  const {
    handleSort,
    sortedData,
    tableSort,
  } = useStatusesTable(data)

  const handleRowClick = useCallback(async analysisStatus => {
    await dispatch(handleSpecificAnalysisStatusSelection(analysisStatus))
    closeModal()
  }, [])

  return (
    <DataTable
      columns={columns}
      className={'table-layout-auto'}
      data={sortedData}
      handleSort={handleSort}
      idRoot={idRoot}
      rowClick={handleRowClick}
      tableSort={tableSort} />
  )
}

StatusesTable.propTypes = {
  closeModal: func.isRequired,
  data: array.isRequired,
  idRoot: string.isRequired,
}


export default StatusesTable
